import React from 'react';
import { formatTeamAnalytics, getTeamPerformanceSummary } from '../utils/teamAnalytics';

const TeamAnalytics = ({ analytics, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-gray-800 rounded-lg p-6">
        <h3 className="text-xl font-semibold text-white mb-4">Team Analytics</h3>
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-gray-700 rounded w-3/4"></div>
          <div className="h-4 bg-gray-700 rounded w-1/2"></div>
          <div className="h-4 bg-gray-700 rounded w-2/3"></div>
        </div>
      </div>
    );
  }

  if (!analytics) {
    return (
      <div className="bg-gray-800 rounded-lg p-6">
        <h3 className="text-xl font-semibold text-white mb-4">Team Analytics</h3>
        <p className="text-gray-400">No analytics data available</p>
      </div>
    );
  }

  const formattedAnalytics = formatTeamAnalytics(analytics);
  const performanceSummary = getTeamPerformanceSummary(analytics);

  return (
    <div className="bg-gray-800 rounded-lg p-6">
      <h3 className="text-xl font-semibold text-white mb-4">Team Analytics</h3>
      
      {/* Performance Summary */}
      <div className="mb-6">
        <p className="text-gray-300 text-sm">{performanceSummary}</p>
      </div>

      {/* Key Metrics Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gray-700 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-green-400">{analytics.gamesPlayed}</div>
          <div className="text-sm text-gray-300">Games Played</div>
        </div>
        
        <div className="bg-gray-700 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-blue-400">{analytics.wins}</div>
          <div className="text-sm text-gray-300">Wins</div>
        </div>
        
        <div className="bg-gray-700 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-yellow-400">{formattedAnalytics.averageScore}</div>
          <div className="text-sm text-gray-300">Avg Score</div>
        </div>
        
        <div className="bg-gray-700 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-purple-400">{formattedAnalytics.winPercentage}%</div>
          <div className="text-sm text-gray-300">Win Rate</div>
        </div>
      </div>

      {/* Additional Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-gray-700 rounded-lg p-4">
          <h4 className="text-lg font-semibold text-white mb-2">Performance</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-300">Best Score:</span>
              <span className="text-white font-medium">{analytics.bestScore}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-300">Total Score:</span>
              <span className="text-white font-medium">{analytics.totalScore}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-300">Current Streak:</span>
              <span className={`font-medium ${analytics.currentStreak > 0 ? 'text-green-400' : analytics.currentStreak < 0 ? 'text-red-400' : 'text-gray-400'}`}>
                {analytics.currentStreak > 0 ? `+${analytics.currentStreak}` : analytics.currentStreak}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-300">Longest Streak:</span>
              <span className="text-white font-medium">{analytics.longestStreak}</span>
            </div>
          </div>
        </div>

        <div className="bg-gray-700 rounded-lg p-4">
          <h4 className="text-lg font-semibold text-white mb-2">Recent Activity</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-300">Last Game:</span>
              <span className="text-white font-medium">{formattedAnalytics.lastGameDate}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-300">Losses:</span>
              <span className="text-white font-medium">{analytics.losses}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-300">Games This Month:</span>
              <span className="text-white font-medium">-</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-300">Games This Week:</span>
              <span className="text-white font-medium">-</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamAnalytics;


